import { render } from "./enterpriseAllocation.vue?vue&type=template&id=28f6412c&scoped=true"
import script from "./enterpriseAllocation.vue?vue&type=script&lang=js"
export * from "./enterpriseAllocation.vue?vue&type=script&lang=js"

import "./enterpriseAllocation.vue?vue&type=style&index=0&id=28f6412c&scoped=true&lang=css"
import "./enterpriseAllocation.vue?vue&type=style&index=1&id=28f6412c&lang=css"
script.render = render
script.__scopeId = "data-v-28f6412c"

export default script